import * as client from './client.js';

export async function getOrganizationUser(userId) {
    return await client.get(`/organizations/user/${userId}`);
}

export async function getOrganizationUsers() {
    return await client.get('/organizations/users');
}

export async function getOrganizations() {
    return await client.get('/organizations');
}

export async function saveMyOrganization(body) {
    return await client.post('/organizations/save', body);
}

export async function deleteMyChildOrganizations(body) {
    return await client.post('/organizations/delete', body);
}
